import * as React from 'react';
import { Task } from './Tasks';

interface TaskAssignNameSelectProps {
  index: number;
  task: Task;
  children: React.ReactNode[];
  onNameChange(index: number, name: string, task: Task): void;
}

export default class TaskAssignNameSelect extends React.Component<TaskAssignNameSelectProps> {
  render() {
    const { children, index } = this.props;
    return (
      <select
        name="name"
        id={`ns${index}`}
        onChange={this.onNameChange}
      >
        {children}
      </select>
    )
  }

  onNameChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const { index, task, onNameChange } = this.props
    const name = event.currentTarget.value;
    onNameChange(index, name, task)
  }
}


// WEBPACK FOOTER //
// ./src/tasks/TaskAssignNameSelect.tsx